// extracted by mini-css-extract-plugin
module.exports = {"loginLeftSideBackground":"styles_loginLeftSideBackground__1LZGE"};